import { Link } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { api } from '../api';
import {
  EmptyState,
  ErrorBox,
  Loader,
  PageHeader,
  formatDuration,
  formatPrice,
} from '../components/Common';

export function ServicesPage() {
  const { data, isLoading, error, refetch } = useQuery({
    queryKey: ['services'],
    queryFn: () => api.services.listPublic(),
  });

  return (
    <div>
      <PageHeader title="Каталог услуг" subtitle="Выберите, что хотите забронировать" />

      {isLoading && <Loader />}
      {error && (
        <ErrorBox message={(error as Error).message} onRetry={() => void refetch()} />
      )}
      {!isLoading && data && data.length === 0 && (
        <EmptyState icon="📭" title="Каталог пуст" hint="Администратор ещё не добавил услуги" />
      )}

      <ul className="space-y-2">
        {data?.map((s) => (
          <li key={s.id}>
            <Link
              to={`/book/${s.id}`}
              className="card flex items-center justify-between active:opacity-80"
            >
              <div className="min-w-0 flex-1 pr-3">
                <p className="font-semibold">{s.name}</p>
                {s.description && (
                  <p className="line-clamp-2 text-xs text-tg-hint">{s.description}</p>
                )}
                <p className="mt-1 text-xs text-tg-hint">
                  {formatDuration(s.duration_minutes)}
                </p>
              </div>
              <div className="text-right">
                <p className="font-semibold">{formatPrice(s.price_min, s.price_max)}</p>
                <p className="text-xs text-tg-link">Записаться ›</p>
              </div>
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
}
